/**
 * brandAssets.js · v2.7.46+E21 (Feb-2026)
 * ─────────────────────────────────────────────────────────────────────
 * Centralised registry of the corporate brand image URLs so every
 * component imports from a single source of truth. Swapping a logo
 * file is a one-line edit here instead of a multi-component sweep.
 *
 * v2.7.46+E21 · Swapped both marks for the freshly delivered,
 * **tightly cropped** PNGs (76 KB / 68 KB). Because the new artwork
 * has no transparent gutter, every consumer can render the asset
 * flush (no `transform: scale()` overscan tricks, no negative-margin
 * crops, no fixed bounding boxes). See AdminLayoutShell, AdminFooter,
 * EmailSettingsPanel, EmailClientPage, DeveloperEmailAdminPage for
 * the cleaned-up wrapper styles.
 */

// TAXI-COMMANDER · drives the admin sidebar header
// v2.7.65+E176 · Swapped to the horizontal "Buller crest · DISPATCH SYSTEM ·
// TAXI COMMANDER" lockup. Landscape orientation, so consumers can render
// it at full container width without eating vertical real estate.
export const TAXI_COMMANDER_LOGO =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_taxi-meter-app-5/artifacts/pgjrmopi_taxi%20dispatch%20logo%20new%204.png";

// BISON SOFTWARE · CORPORATE EMAIL SYSTEM — used across all
// Corporate-Email surfaces (page header, footer, settings panel,
// email admin dashboard).
export const BISON_CORPORATE_EMAIL_LOGO =
  "https://customer-assets.emergentagent.com/job_taxi-meter-app-5/artifacts/uwhudx3y_BISONEMAIL%20LOGO.png";
